import React from 'react';
import { BrowserRouter, Routes, Route, ScrollRestoration } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { MembershipPage } from './pages/MembershipPage';
import { EventsPage } from './pages/EventsPage';
import { CharityPage } from './pages/CharityPage';
import { TeamPage } from './pages/TeamPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
export function App() {
  return <HelmetProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
            <Route index element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
            <Route path="membership" element={<MembershipPage data-id="element-10" />} data-id="element-9" />
            <Route path="events" element={<EventsPage data-id="element-12" />} data-id="element-11" />
            <Route path="charity" element={<CharityPage data-id="element-14" />} data-id="element-13" />
            <Route path="team" element={<TeamPage data-id="element-16" />} data-id="element-15" />
            <Route path="contact" element={<ContactPage data-id="element-18" />} data-id="element-17" />
            <Route path="privacy" element={<PrivacyPolicyPage data-id="element-20" />} data-id="element-19" />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}